<template>
  <div class="CopayForm">
    <h2 class="gl_form-title">
      {{ t('rater.health.copay.form-legend') }}
    </h2>

    <CardInfoComponent
      v-if="message"
      :icon="message.icon"
    >
      {{ message.label }}
    </CardInfoComponent>

    <RadioButtonGroup
      id="main"
      :value="copayType"
      v-model="copayType"
      :options="copayOptions"
      :rules="[validationRules.required]"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
import { useRules } from '@/modules/core/composables/useRulesComposable'

defineExpose({ triggerSubmit })

interface PropsInterface {
  nextForm: String[]
  answers: Record<string, any>
  configurations: Record<string, any>
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const { t } = useI18n()
const { required } = useRules()

const validationRules = {
  required: (value: string) => required(value, 'common.validations.option')
}

const copayOptions = ref(props.configurations.copaymentTypesOptions)
const copayType = ref(props.answers.copayType ?? props.configurations.defaultCopaymentType)
const message = ref(props.configurations.tags.copayAlert)

function triggerSubmit() {
  const page = props.nextForm[0]
  const answers = {
    copayType: copayType.value
  }

  return { page, answers }
}
</script>
